'use client'

import { BoxProps as ChakraBoxProps, ImageProps as ChakraImageProps, Image, Skeleton } from '@chakra-ui/react'
import { useState } from 'react'

type ChakraNextImageProps = ChakraBoxProps &
  ChakraImageProps & {
    alt: string
    src: string
    height?: ChakraImageProps['height'] | number | string
    width?: ChakraImageProps['width'] | number | string
    borderRadius?: string
    disableSkeleton?: boolean
  }

export default function ChakraImage({
  alt,
  src,
  height,
  width,
  borderRadius = 'md',
  disableSkeleton = false,
  ...rest
}: ChakraNextImageProps) {
  const [isLoaded, setIsLoaded] = useState(disableSkeleton)

  if (!src || !height || !width) return null

  return (
    <Skeleton
      alignSelf='center'
      justifySelf='center'
      loading={!isLoaded}
      borderRadius={borderRadius}
      height={!height ? 'auto' : height}
      width={!width ? 'auto' : width}>
      <Image
        src={src}
        alt={alt}
        height={height}
        width={width}
        borderRadius={borderRadius}
        onLoad={() => setIsLoaded(true)}
        {...rest}
      />
    </Skeleton>
  )
}
